import { Button, Checkbox, Form, Input, Select } from "antd";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { VIDEO_ACTIONS } from "../../redux/video/action";
import ImageUploader from "../ImageUploader";

const VideoForm = ({
  updateData = null,
  isUpdate = false,
  isUpdateComplete,
  activeTab,
}) => {
  const [form] = Form.useForm();
  const [flip, setFlip] = useState(false);
  const [imageData, setImageData] = useState([]);
  const [chapterDataList, setChapterDataList] = useState([]);
  const dispatch = useDispatch();

  const { data: chapterDataArray } = useSelector(
    (reducers) => reducers.chapterReducer,
  );

  const { formError = {} } = useSelector((reducers) => reducers.videoReducer);

  useEffect(() => {
    if (updateData) {
      form.setFieldsValue({
        name: updateData?.name,
        isFree: updateData.isFree,
        link: updateData.link,
        chapterId: updateData.chapterId,
      });
      setImageData(updateData?.image);
    }
    if (!isUpdate) {
      form.setFieldsValue({
        name: "",
        isFree: false,
        link: "",
        chapterId: "",
      });
    }
  }, [updateData]);

  useEffect(() => {
    setChapterDataList(chapterDataArray);
  }, [chapterDataArray]);

  const onFinish = (values) => {
    dispatch({ type: VIDEO_ACTIONS.SET_STATE, payload: { formError: {} } });

    if (isUpdate) {
      dispatch({
        type: VIDEO_ACTIONS.UPDATE_VIDEO,
        payload: {
          path: { id: updateData.id },
          body: {
            name: values.name,
            image: imageData?.[0]?.key,
            isFree: values.isFree,
            link: values.link,
            chapterId: values.chapterId,
          },
        },
      });
    } else {
      dispatch({
        type: VIDEO_ACTIONS.CREATE_VIDEO,
        payload: {
          body: {
            name: values.name,
            image: imageData?.[0]?.key,
            isFree: values.isFree,
            link: values.link,
            chapterId: values.chapterId,
          },
        },
      });
      form.setFieldsValue({ name: "", isFree: false, link: "", chapterId: "" });
    }
  };

  return (
    <>
      <Form layout={"vertical"} form={form} onFinish={onFinish}>
        <Form.Item
          label="Title"
          name="name"
          required
          validateStatus={formError?.name?.length ? "error" : ""}
          help={formError?.name?.length ? formError.name[0] : ""}
        >
          <Input placeholder="Input name" />
        </Form.Item>

        <Form.Item
          label="Upload Thumbnail"
          name="imageLink"
          required
          validateStatus={formError?.image?.length ? "error" : ""}
          help={formError?.image?.length ? formError.image[0] : ""}
        >
          <ImageUploader
            fileData={imageData}
            setFileData={setImageData}
            flip={flip}
          />
        </Form.Item>

        <Form.Item
          label="Free Topic?"
          name="isFree"
          valuePropName="checked"
          required
          validateStatus={formError?.isFree?.length ? "error" : ""}
          help={formError?.isFree?.length ? formError.isFree[0] : ""}
        >
          <Checkbox>Check this box if it's a free video.</Checkbox>
        </Form.Item>

        <Form.Item
          label="Video Link"
          name="link"
          required
          validateStatus={formError?.link?.length ? "error" : ""}
          help={formError?.link?.length ? formError.link[0] : ""}
        >
          <Input placeholder="Input Video Link" />
        </Form.Item>

        <Form.Item
          name="chapterId"
          label="Chapter"
          required
          validateStatus={formError?.chapterId?.length ? "error" : ""}
          help={formError?.chapterId?.length ? formError.chapterId[0] : ""}
        >
          <Select placeholder="Select Chapter">
            {chapterDataList?.map((item) => (
              <Select.Option key={item.id} value={item.id}>
                {item.name}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item>
          {isUpdate ? (
            <>
              <Button
                type="dashed"
                style={{ backgroundColor: "#f5c542" }}
                htmlType="submit"
              >
                Update
              </Button>
            </>
          ) : (
            <>
              <Button type="primary" htmlType="submit">
                Add
              </Button>
            </>
          )}
        </Form.Item>
      </Form>
    </>
  );
};

export default VideoForm;
